module.exports = __webpack_public_path__ + "img/google-play-btn.9af9fdc22c611773ccff7c50cffed97c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/assets/img/google-play-btn.svg
 ** module id = 64
 ** module chunks = 0
 **/